import {AfterViewInit, ChangeDetectorRef, Component, Input, NgZone, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {ProductsService} from '../services/products.service';

@Component({
  selector: 'app-manage-products',
  templateUrl: './manage-products.component.html',
  styleUrls: ['./manage-products.component.css']
})
export class ManageProductsComponent implements OnInit, AfterViewInit {
  public pageTitle = 'Product Management';
  p = 1;
  public filter = '';
  @Input() searchFilterText: string;
  searchResults: any [];
  productCategories: any[];
  mySpinner: boolean;
  cloneProductList;
  firstTimeSort = true;

  constructor(private router: Router,
              private ngZone: NgZone,
              private changeDetect: ChangeDetectorRef,
              private service: ProductsService) { }

  ngOnInit() {
    // initial button states
    this.mySpinner = false;
  }

  FilterAndSetButtonState(value?: string) {
    if (value === 'custom') {
      this.filter = 'custom-' + this.searchFilterText;
    } else {
      this.filter = value;  // update filter
    }
  }

  gotoDetails(category) {
    // this.eventService.setSelectedEvent(event);
    this.router.navigateByUrl('/product-category-detail/' + category.id);
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.mySpinner = true;
      this.service.getProductCategories().subscribe((res) => {
        this.ngZone.run(() => {
          this.productCategories = res;
          if (this.productCategories.length > 0) {
            this.doSort('namea-z');
            if (!this.changeDetect['destroyed']) {
              this.changeDetect.detectChanges();
              this.mySpinner = false;
            }
          }
        });
      });
    }, 500);
  }

  doSort(val) {
    console.log('sort by', val);
    // sort maseter list by val, in place
    if (this.firstTimeSort) {
      // first time we sort by date
      this.productCategories.sort((event1, event2) => {
        if (event1.name > event2.name) {
          return 1;
        }
        if (event1.name < event2.name) {
          return -1;
        }
        return 0;
      });
      this.cloneProductList = this.productCategories.slice();
      this.firstTimeSort = false;
      return;
    }

    if (val === 'namea-z') {
      this.productCategories.sort((event1, event2) => {
        if (event1.name > event2.name) {
          return 1;
        }
        if (event1.name < event2.name) {
          return -1;
        }
        return 0;
      });
    } else if (val === 'namez-a') {
      this.productCategories.sort((event1, event2) => {
        if (event2.name > event1.name) {
          return 1;
        }
        if (event2.name < event1.name) {
          return -1;
        }
        return 0;
      });
    } else { // no sort
      this.productCategories = this.productCategories.slice();
    }
  }

  eventHandler(event) {
    setTimeout(() => {
      this.ngZone.run(() => {
        this.filter = 'custom-' + this.searchFilterText;
        if (!this.changeDetect['destroyed']) {
          this.changeDetect.detectChanges();
        }
      });
    }, 100);
  }
  unfocus(event) {
    setTimeout(() => {
      this.ngZone.run(() => {
        this.filter = '';
        this.searchFilterText = '';
        if (!this.changeDetect['destroyed']) {
          this.changeDetect.detectChanges();
        }
      });
    }, 100);
  }
}
